// extracted by mini-css-extract-plugin
export default {"accordionContent":"DeliverablesPhasesList_accordionContent__Xd5An","line":"DeliverablesPhasesList_line__9n7j9"};